<template>
  <div :class="['loading-icon', loadingIconClasses]">
    <svg version="1.1"
       class="loading-icon-svg"
       viewBox="0 0 405 405"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       xml:space="preserve">
    <g class="loading-icon-leaf-wrapper-outer"
       data-animator-group="true"
       data-animator-type="1">
      <g class="loading-icon-leaf-wrapper-inner" data-animator-group="true" data-animator-type="2">
        <path class="loading-icon-leaf" d="M368.899,272.314c-25.39-16.037-54.678-24.514-84.697-24.514c-1.054,0-2.108,0.016-3.162,0.037
        c34.507-27.094,59.146-65.556,68.972-108.692c0.495-2.175-0.159-4.451-1.732-6.031c-1.575-1.581-3.853-2.244-6.024-1.756
        c-35.557,7.956-67.984,25.74-93.773,51.428c-1.952,1.942-3.858,3.933-5.727,5.961c1.675-11.418,2.532-22.99,2.532-34.637
        c0-45.082-12.726-89.056-36.802-127.169c-1.19-1.886-3.265-3.029-5.495-3.029s-4.305,1.143-5.495,3.029
        c-24.076,38.114-36.802,82.088-36.802,127.169c0,11.648,0.857,23.22,2.532,34.638c-1.869-2.027-3.775-4.018-5.726-5.959
        c-25.791-25.69-58.218-43.475-93.775-51.431c-2.172-0.488-4.45,0.175-6.024,1.756c-1.573,1.58-2.228,3.856-1.732,6.031
        c9.826,43.136,34.464,81.598,68.972,108.692c-1.054-0.021-2.107-0.037-3.161-0.037c-30.02,0-59.308,8.477-84.697,24.514
        c-1.886,1.191-3.029,3.266-3.029,5.496s1.144,4.305,3.029,5.496c24.396,15.409,51.878,23.719,80.344,24.451
        c-6.288,6.974-11.662,14.731-16.053,23.201c-1.027,1.98-0.966,4.35,0.16,6.275c1.127,1.925,3.163,3.138,5.393,3.213
        c1.221,0.041,2.437,0.061,3.653,0.061c33.486-0.001,65.127-15.431,85.913-40.998v63.615c0,3.59,2.91,6.5,6.5,6.5s6.5-2.91,6.5-6.5
        v-63.612c20.785,25.567,52.422,40.996,85.911,40.996c1.215,0,2.435-0.021,3.653-0.061c2.229-0.075,4.266-1.288,5.392-3.213
        c1.127-1.925,1.188-4.294,0.161-6.274c-4.396-8.482-9.78-16.251-16.08-23.233c28.343-0.821,56.358-9.252,80.371-24.419
        c1.886-1.191,3.029-3.266,3.029-5.496S370.784,273.505,368.899,272.314z M257.654,192c21.49-21.405,47.921-36.924,76.961-45.278
        c-12.816,43.752-42.149,81.468-81.713,104.586c-11.487,6.71-23.648,12.095-36.299,16.099c8.715-16.101,15.513-33.082,20.298-50.624
        C243.038,207.942,250.01,199.605,257.654,192z M202.99,43.056c19.198,33.835,29.297,72.005,29.297,111.054
        c0,39.048-10.099,77.218-29.297,111.054c-19.198-33.836-29.297-72.006-29.297-111.054
        C173.693,115.061,183.792,76.891,202.99,43.056z M71.364,146.722c29.04,8.354,55.472,23.873,76.963,45.281
        c7.639,7.601,14.612,15.937,20.753,24.782c4.785,17.541,11.583,34.522,20.298,50.623c-12.652-4.004-24.813-9.389-36.3-16.1
        C113.513,228.19,84.18,190.474,71.364,146.722z M121.777,260.801c8.666,0,17.331,0.787,25.776,2.322
        c12.137,6.99,24.961,12.614,38.293,16.802c-16.325,7.99-34.096,12.927-52.17,14.394c-0.131,0.01-0.262,0.025-0.392,0.044
        c-27.949,2.211-55.314-3.494-79.804-16.549C74.477,266.656,97.875,260.801,121.777,260.801z M118.713,327.163
        c5.064-7.51,11.136-14.228,18.119-20.089c15.745-1.494,31.248-5.388,45.872-11.469C166.226,313.627,143.311,325.08,118.713,327.163
        z M223.277,295.606c14.623,6.081,30.125,9.974,45.869,11.469c6.983,5.861,13.056,12.579,18.119,20.089
        C262.671,325.079,239.755,313.626,223.277,295.606z M272.697,294.364c-0.131-0.019-0.264-0.034-0.396-0.044
        c-18.075-1.468-35.845-6.404-52.169-14.394c13.332-4.188,26.156-9.812,38.294-16.802c8.444-1.536,17.109-2.322,25.776-2.322
        c23.902,0,47.301,5.855,68.296,17.014C328.009,290.869,300.646,296.57,272.697,294.364z"></path>
      </g>
    </g>
    <g class="loading-icon-circle-wrapper" data-animator-group="true" data-animator-type="2">
      <path class="loading-icon-circle" d="M202.99,0C91.061,0,0,91.061,0,202.99s91.061,202.99,202.99,202.99s202.99-91.061,202.99-202.99S314.92,0,202.99,0z
       M202.99,392.98C98.229,392.98,13,307.751,13,202.99S98.229,13,202.99,13s189.99,85.229,189.99,189.99
      S307.751,392.98,202.99,392.98z"></path>
    </g>
  </svg>
  </div>
</template>

<script>
  export default {
    props: {
      loadingIconClasses: String,
    },

    name: 'LoadingIcon',
  }
</script>